export default "__VITE_ASSET__CUNvChgo__"